import React from 'react';

const LoadingBar = () => {
  return (
    <div className="h-0.5 w-full bg-gray-200 overflow-hidden">
      <div className="w-full h-full bg-[--color-primary] animate-indeterminate-progress origin-left"></div>
    </div>
  );
};

const styles = `
  @keyframes indeterminateProgress {
    0% {
      transform: translateX(-100%) scaleX(0.5);
    }
    50% {
      transform: translateX(0%) scaleX(0.5);
    }
    100% {
      transform: translateX(100%) scaleX(0.5);
    }
  }
  
  .animate-indeterminate-progress {
    animation: indeterminateProgress 1s infinite linear;
  }
`;


export default function LoadingBarWithStyles() {
  return (
    <>
      <style>{styles}</style>
      <LoadingBar />
    </>
  );
}